var rich_content_viewer_default = {
  "fontElementMap": "VvKlC",
  "wrapper": "nIlW2",
  "pluginContainerMobile": "wj0S7",
  "viewer": "C0hbR",
  "android": "_2DxfQ",
  "rootedTraversedContent": "av0i6",
  "atomic": "DxLcq",
  "toolbar": "eqffX",
  "block": "gwz8J"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
